import React from 'react';
import { useParams } from 'react-router-dom';

const DynamicHeadings = ({ value, className }) => {
  let defaultValue = value;
  let { category_name } = useParams();
  let cssClassName = {};
  category_name = category_name ? category_name.trim().toLowerCase().replace(/-/g, ' ') : 'menu';
  value = value?.replace(/ &|'/g, '');
  if (className) {
    cssClassName = { className };
  }

  return (
    <>
      {category_name === value?.trim().toLowerCase() ? (
        <h1 {...cssClassName}>{defaultValue}</h1>
      ) : (
        <h2 {...cssClassName}>{defaultValue}</h2>
      )}
    </>
  );
};
export default DynamicHeadings;
